import { useState, useEffect } from 'react';
import {LOCAL_STORAGE_KEYS } from '../constants';
import {UserService} from '../services';

export default function UseAuthentification() {

  function  handleLogout() {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
    window.location.href = "/login"
  }

 function  handleLogin(response, navigate) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, response.token);
    //message.success("STORE MANAGER : Bienvenue", 10);
    navigate && navigate("/");
  }

  const [currentUser, setCurrentUser] = useState(null);
  useEffect(() => {
    UserService.getUserInfo().then(setCurrentUser).catch(error=> {
      console.log("Error getting current user")
    })
  },[localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)]);

 const [isAuthenticated, setIsAuthenticated] = useState(true);

  useEffect(() => {
      setIsAuthenticated(((LOCAL_STORAGE_KEYS && LOCAL_STORAGE_KEYS.ACCESS_TOKEN && localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)) ? true : false))
  }, [localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)]);

  return {onLogout : handleLogout, onLogin : handleLogin, isAuthenticated : isAuthenticated, currentUser:currentUser};
}